import { toastr } from 'react-redux-toastr';
import axiosPublicApi from '../main/axios-public';
import axiosInstance from '../main/axios';
import socketService from '../services/socketService';
import { wireMapaFaseSocketBridge, syncMapaFaseRoute } from '../fase/mapaFaseSocketBridge';

// Helper para logar e tentar autenticar
function attemptSocketAuth(source) {
  socketService.tryAuthenticate();
}

export function login(values) {
  return submit(values, `/login`, 'login');
}

export function signup(values) {
  return submit(values, `/signup`, 'signup');
}

// Nova ação para buscar a configuração do cliente
export function getClientConfig() {
  return dispatch => {
    axiosInstance
      .get(`/config/cliente`)
      .then(resp => {
        dispatch({ type: 'CLIENT_CONFIG_FETCHED', payload: resp.data });
        if (resp.data && resp.data.mapa_fase_socket) {
          wireMapaFaseSocketBridge();
          socketService.connect();
          socketService.tryAuthenticate();
          syncMapaFaseRoute(
            (window.location.hash || '').replace(/^#/, '') || '/',
            resp.data,
          );
        }
      })
      .catch(e => {
        console.error('authActions (getClientConfig): Erro na API!', e);
        toastr.error('Erro', 'Falha ao buscar configuração do cliente.');
      });
  };
}

/** Recarrega hashes de permissão do usuário logado (evita relogin após editar grupo). */
export function refreshSessionPermissions(options = {}) {
  const { silent = false } = options;

  return dispatch =>
    axiosInstance
      .get('/auth/permissoes')
      .then(resp => {
        const userKey = '_ssat';
        const current = JSON.parse(localStorage.getItem(userKey) || '{}');
        const updated = { ...current, data: resp.data.data };
        localStorage.setItem(userKey, JSON.stringify(updated));
        dispatch({ type: 'USER_PERMISSIONS_REFRESHED', payload: updated });
        if (!silent) {
          toastr.info('Permissões atualizadas', 'Sua sessão refletiu as alterações do grupo.');
        }
        return updated;
      })
      .catch(e => {
        console.error('authActions (refreshSessionPermissions):', e);
        if (!silent) {
          toastr.warning('Permissões', 'Salvo no banco, mas não foi possível atualizar a sessão. Faça login novamente.');
        }
        throw e;
      });
}

function submit(values, url, source) {
  return dispatch => {
    axiosPublicApi
      .post(url, values)
      .then(resp => {
        // ---> PASSO CRÍTICO: Salvar dados no localStorage AQUI <---
        if (resp.data) {
          const userKey = '_ssat';
          localStorage.setItem(userKey, JSON.stringify(resp.data));
        } else {
          console.error(`authActions (${source}): Resposta da API não contém dados para salvar!`);
          // Considerar não prosseguir se não houver dados
        }

        // Agora que o localStorage FOI setado, despacha a ação para o Redux
        dispatch([{ type: 'USER_FETCHED', payload: resp.data }]);

        // Busca a configuração do cliente
        dispatch(getClientConfig());

        // E AGORA podemos tentar autenticar o socket com segurança
        attemptSocketAuth(source);
      })
      .catch(e => {
        console.error(`authActions (${source}): Erro na API!`, e);
        console.error('authActions: Detalhes do Erro:', e.response);
        if (e.response && e.response.data && e.response.data.errors) {
          e.response.data.errors.forEach(error => toastr.error('Erro', error));
        } else {
          toastr.error('Erro', 'Falha na comunicação com o servidor. Verifique o console.');
        }
      });
  };
}

export function logout() {
  socketService.disconnect();
  const userKey = '_ssat';
  localStorage.removeItem(userKey);

  const notificationsKey = '_ssat_notifications';
  localStorage.removeItem(notificationsKey);

  return { type: 'TOKEN_VALIDATED', payload: false };
}

export function validateToken(token) {
  return dispatch => {
    if (token) {
      axiosPublicApi
        .post(`/validateToken`, { token })
        .then(resp => {
          dispatch({ type: 'TOKEN_VALIDATED', payload: resp.data.valid });

          if (resp.data.valid) {
            attemptSocketAuth('validateToken');
            dispatch(getClientConfig());
          } else {
            const userKey = '_ssat';
            localStorage.removeItem(userKey);
          }
        })
        .catch(e => {
          console.error('authActions (validateToken): Erro na API!:', e);
          console.error('authActions: Detalhes do Erro:', e.response);
          dispatch({ type: 'TOKEN_VALIDATED', payload: false });
          const userKey = '_ssat';
          localStorage.removeItem(userKey);
        });
    } else {
      dispatch({ type: 'TOKEN_VALIDATED', payload: false });
      const userKey = '_ssat';
      localStorage.removeItem(userKey);
    }
  };
}
